export default [
  {
    name: 'carta-pax',
    path: '/carta-pax',
    component: () => import(/* webpackChunkName: "carta-pax" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Carta Pax',
      icon: 'dvr',
      label: 'Carta Pax',
      roles: ['Admin']
    }
  },
  {
    name: 'carta-pax-new',
    path: '/carta-pax/new',
    component: () => import(/* webpackChunkName: "carta-pax-builder" */ './Builder.vue'),
    meta: {
      showNavbar: true,
      title: 'Nova Carta Pax',
      icon: 'dvr',
      label: 'Nova Carta Pax',
      roles: ['Admin']
    }
  },
  {
    name: 'carta-pax-edit',
    path: '/carta-pax/:id/edit',
    component: () => import(/* webpackChunkName: "carta-pax-builder" */ './Builder.vue'),
    meta: {
      showNavbar: true,
      title: 'Editar Carta Pax',
      icon: 'dvr',
      label: 'Editar Carta Pax',
      roles: ['Admin']
    }
  }
]
